exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coupon-container[data-v-15f24157]{margin:20px 0 0 20px;background:#fff;padding:10px;min-height:calc(100vh - 120px)}.coupon .err[data-v-15f24157]{color:red}", ""]);

// exports
